import { Menu, MenuDivider, MenuItem } from "@szhsin/react-menu";
import { g } from "analytics";
import React from "react";
import { useTranslation } from "react-i18next";
import { Bcn } from "support/beacon";
import { Tip } from "view/tooltips";
export const LanguagePicker = () => {
    const { t } = useTranslation();
    return React.createElement(Menu, { menuButton: React.createElement("div", { className: "menuBarItem" },
            React.createElement("i", { className: "far fa-globe" }),
            " ",
            t("currentLanguage")), portal: true, transition: true },
        React.createElement(LanguageOptions, null));
};
export const LanguageOptions = () => {
    const { i18n, t } = useTranslation();
    function changeLanguage(lang) {
        g("ChangeLanguage", lang);
        i18n.changeLanguage(lang);
    }
    return React.createElement(React.Fragment, null,
        React.createElement(MenuItem, { onClick: () => changeLanguage("en") },
            React.createElement(Globe, null),
            "English"),
        React.createElement(MenuItem, { onClick: () => changeLanguage("de") },
            React.createElement(Globe, null),
            "Deutsch"),
        React.createElement(MenuItem, { onClick: () => changeLanguage("es") },
            React.createElement(Globe, null),
            "Espa\u00F1ol"),
        React.createElement(MenuItem, { onClick: () => changeLanguage("fr") },
            React.createElement(Globe, null),
            "Fran\u00E7ais"),
        React.createElement(MenuItem, { onClick: () => changeLanguage("zh") },
            React.createElement(Globe, null),
            "\u4E2D\u6587 (\u7B80\u4F53)"),
        React.createElement(MenuDivider, null),
        React.createElement(Tip, { content: t("beacon.translation_bug.menu_hint") },
            React.createElement(MenuItem, { onClick: () => Bcn.reportTranslationBug() },
                React.createElement("i", { className: "fas fa-pencil-mechanical" }),
                t("beacon.translation_bug.menu"))));
};
export const Globe = () => React.createElement("i", { className: "far fa-globe" });
